import axios from 'axios';
import { CreateManualFeedInput } from '../types/create-manual-feed-input.type';
import { ManualFeed } from '../types/manual-feed.type';

// POST
// Add feed.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}​/feed
export const postManualFeed = async (globalCompanyId: string, request: CreateManualFeedInput): Promise<ManualFeed> => {
  const res = await axios.post<ManualFeed>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/feed`, request);
  return res.data;
};
